import {Trans} from '@lingui/macro'
import styled from 'styled-components'

import {Link, Stack, Text, tokens} from '@pleo-io/telescope'

import {getHelpCentreArticleLink} from '@product-web/locale/helpers'
import {breakpoints} from '@product-web/styles/theme'

import Screen from '../../../components/auth-flow-screen-template'
import VerifyEmail from '../../../images/verify-email.svg'

export function EmailValidationScreen() {
    return <EmailValidationScreenContentV2 />
}

const EmailValidationScreenContentV2 = () => {
    return (
        <Screen
            imgSrc={VerifyEmail}
            hideImageOnSmallScreen={true}
            hideLogoOnSmallScreen={false}
            hideBackButton={true}
        >
            <Wrapper>
                <Stack space={24} stretch>
                    <Text variant="3xlarge-accent">
                        <Trans>Verify your email</Trans>
                    </Text>
                    <Stack space={8}>
                        <Text variant="medium-default">
                            <Trans>
                                We've sent you an email. Go to your inbox and follow the link to
                                continue logging in.
                            </Trans>
                        </Text>
                        <Link
                            href={getHelpCentreArticleLink(
                                '103000284453-issues-with-verification-email',
                            )}
                            target="_blank"
                        >
                            <Trans>Didn't get an email?</Trans>
                        </Link>
                    </Stack>
                </Stack>
            </Wrapper>
        </Screen>
    )
}

const Wrapper = styled.div`
    @media (max-width: ${breakpoints.mobileLrgUp}) {
        margin: ${tokens.spacing20};
    }
`
